import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";

var backend = require('../../config.js').backend;

class DonationGroupsPopUp extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      desigId: props.desigId,
      desigName: props.desigName,
      groupId: props.groupId,
      originalGroup: props.groupId,
      chooseGroup: props.groupId,
      groups: props.groups,
      redirectLogout: false
    }

    this.handleChooseGroup = this.handleChooseGroup.bind(this);

  }



  // Update donation group
  handleChooseGroup = groupId => {
    // console.log('choose new group', groupId);
    this.setState({ chooseGroup: groupId })
  }

  handleConfirm = _ => {
    var { desigId } = this.state;
    var { chooseGroup } = this.state;
    // console.log('chooseGroup', chooseGroup);

    fetch(backend + 'api/v1/desig/donationgroup/' + desigId + '/' + chooseGroup, {
      method: 'PUT',
      credentials: "include"
    })
      .then(data => {
        // console.log(data);
        if (data.redirect) {
          this.setState({ redirectLogout: true })
          window.location.reload(false);
        }
        else {
          NotificationManager.success('Donation group is updated successfully');
          this.props.refresh();
          // return data
        }
      })
      .catch(err => err);

    this.props.closePopup()

  }


  renderSinAdminTick = (group) => {

    if (group.SinAdmin === true) {
      return (<td><CheckIcon /></td>)
    }
    else {
      return (<td></td>)
    }

  }

  renderCheckBox = (group) => {
    var { chooseGroup } = this.state;
    var row_groupId = group.DonationGroupID;

    if (row_groupId === chooseGroup) {
      return (<td><input onChange={() => this.handleChooseGroup(row_groupId).bind(this)} class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value={row_groupId} checked /></td>)
    }

    else {
      return (<td><input onChange={() => this.handleChooseGroup(row_groupId).bind(this)} class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value={row_groupId} /></td>)
    }

  }

  renderGroupName = (group) => {
    var { originalGroup } = this.state;
    var row_groupId = group.DonationGroupID;

    if (row_groupId === originalGroup) {
      return (<td>{group.GroupName} (current group)</td>)
    }
    else {
      return (<td>{group.GroupName}</td>)
    }

  }

  renderRow = (group, index) => {

    var row_groupId = group.DonationGroupID;

    return (
      <tr key={row_groupId} onClick={() => this.handleChooseGroup(row_groupId)}>
        {this.renderCheckBox(group)}
        {this.renderGroupName(group)}
        {this.renderSinAdminTick(group)}
      </tr>
    )


  }

  renderGroups = groups => {

    if (groups.length) {
      return (
        <tbody>
          {groups.map(this.renderRow)}
        </tbody>
      )
    }

  }



  render() {

    const { redirectLogout } = this.state;

    if (redirectLogout) {
      return (
        <BrowserRouter>
          <Switch>
            <Route exact path="/logout" component={Logout} />
            <Redirect to="/logout" />
          </Switch>
        </BrowserRouter>
      )
    }

    var { groups } = this.state;
    var { desigName } = this.state;
    var groups_list = this.renderGroups(groups);
    // console.log(groups_list);

    return (
      <div className='popup'>


        <div className='popup_inner'>
          <span className="close" onClick={this.props.closePopup}>×</span>

          <div className="table-container2">
            <h4>{desigName}:</h4>
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th className='current'>Current Group</th>
                  <th className='group-name'>Group Name</th>
                  <th className='sin-admin'>Sin Admin</th>
                </tr>
              </thead>
              {groups_list}
            </table>
          </div>

          <div className='button'>
            <button type="button" className="btn btn-primary" onClick={this.handleConfirm}>Save</button>
          </div>

        </div>
        <NotificationContainer />

      </div>
    );
  }
}


export default DonationGroupsPopUp;
